import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async ({
    userId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.roles.getUserRoles, { userId }, options);
    if (error) return { error, status };
    return content || {};
};
